export class Icon {

    map =new Map ([
        ["Assets", "warranty"],
        ["Warranty", "assetmanager"],
        ["Performance Manager", "assetmanager"],
        ["Maintenance", "assetmanager"],
        ["Compliance Manager", "assetmanager"]

    ]);

    public getIcon(subgroup: string):string{

        return this.map.get(subgroup);
    }
}
